import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";
import { newUserApi } from "../services/users";

export const authSlice = createSlice({
  name: "auth",
  initialState: {
    accessToken: Cookies.get("access_token") || null,
    refreshToken: Cookies.get("refresh_token") || null,
    activityAccessToken: null,
    accessRoutes: [],
    sessionExpired: false,
    permissions: null,
    accessDenied: false,
    moduleRoutes: {},
    roleId: "",
    isLoggedIn: false,
    isCheckingSession: true,
  },
  reducers: {
    setAccessToken: (state, action) => {
      state.accessToken = action.payload;
      Cookies.set("access_token", action.payload);
    },
    setActivityAccessToken: (state, action) => {
      state.activityAccessToken = action.payload;
    },
    setRefreshToken: (state, action) => {
      state.refreshToken = action.payload;
      Cookies.set("refresh_token", action.payload);
    },
    setAccessRoutes: (state, action) => {
      state.accessRoutes = action.payload;
    },
    setRoleId: (state, action) => {
      state.roleId = action.payload;
    },

    setLoggedIn: (state, action) => {
      state.isLoggedIn = action.payload;
    },
    setCheckingSession: (state, action) => {
      state.isCheckingSession = action.payload;
    },
    showSessionExpiredModal: (state, action) => {
      state.sessionExpired = true;
      if (action.payload) sessionStorage.setItem("returnPath", action.payload);
    },
    hideSessionExpiredModal: (state) => {
      state.sessionExpired = false;
      state.isLoggedIn = false;
      state.accessRoutes = [];
    },
    setPermissions: (state, action) => {
      state.permissions = action.payload;
    },
    showAccessDeniedModal: (state) => {
      state.accessDenied = true;
    },
    setModuleRoutes: (state, action) => {
      state.moduleRoutes = action.payload;
    },
    hideAccessDeniedModal: (state) => {
      state.accessDenied = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAccessRoutes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAccessRoutes.fulfilled, (state, action) => {
        state.accessRoutes = action.payload || [];

        state.loading = false;
        state.error = null;
      })
      .addCase(getAccessRoutes.rejected, (state, action) => {
        state.loading = false;

        state.error = action.error.message;
      })
      .addCase(getAccessibleRoutes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAccessibleRoutes.fulfilled, (state, action) => {
        state.loading = false;
        state.moduleRoutes = action.payload.ui_access_routes || {};
        state.roleId = action.payload.role_id;
      })
      .addCase(getAccessibleRoutes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const getAccessRoutes = createAsyncThunk(
  "auth/getAccessRoutes",
  async (data, { rejectWithValue }) => {
    try {
      return data;
    } catch (err) {
      return rejectWithValue(err.message || "Unknown error");
    }
  },
);

export const getAccessibleRoutes = createAsyncThunk(
  "auth/getAccessibleRoutes",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const response = await dispatch(
        newUserApi.endpoints.fetchAccessModules.initiate(),
      ).unwrap();
      return response?.response;
    } catch (error) {
      return rejectWithValue(error.message || "Unknown error");
    }
  },
);

export const globalSearchSlice = createSlice({
  name: "search",
  initialState: {
    searchTerm: "",
    openSearchBar: false,
    appData: {},
  },
  reducers: {
    setSearchTerm: (state, action) => {
      state.searchTerm = action.payload;
    },
    setAppData: (state, action) => {
      state.appData = action.payload;
    },
    setOpenSearchBar: (state, action) => {
      state.openSearchBar = action.payload;
    },
  },
});

export const {
  setAccessToken,
  setActivityAccessToken,
  setRefreshToken,
  showSessionExpiredModal,
  hideSessionExpiredModal,
  setPermissions,
  showAccessDeniedModal,
  hideAccessDeniedModal,
  setRoleId,
  setModuleRoutes,
  setAccessRoutes,
  setLoggedIn,
  setCheckingSession,
} = authSlice.actions;

export const { setSearchTerm, setAppData, setOpenSearchBar } =
  globalSearchSlice.actions;

export const globalSearchReducer = globalSearchSlice.reducer;

export default authSlice.reducer;
